import script from "./NewsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPage.vue?vue&type=script&setup=true&lang=js"

import "./NewsPage.vue?vue&type=style&index=0&id=af4ae076&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af4ae076"]])

export default __exports__